import { isBuiltCampaignComponentVariableResponse } from "./type-guards";
import BuiltCampaignComponentVariable from "../BuiltCampaignComponentVariable";
export const createBuiltCampaignComponentVariable = (response, context) => {
    if (isBuiltCampaignComponentVariableResponse(response)) {
        return new BuiltCampaignComponentVariable(response, context);
    }
    return null;
};
export const createBuiltCampaignComponentVariables = (responses, context) => {
    const variables = [];
    responses.forEach((response) => {
        const variable = createBuiltCampaignComponentVariable(response, context);
        if (variable) {
            variables.push(variable);
        }
    });
    return variables;
};
